import React from "react";
import "../Navigation/css/NavBar.scss";

export default function UseCases() {
    return (
        <div>
            UseCases
        </div>
    )
}